export default __webpack_public_path__ + "77e181cfa8a052dd092bd7e4e8901125.svg";